/**
 * The workspace the UI is currently working in. The /w/$slug route sets it; the
 * API client sends it as `x-workspace-id` on every call. The server re-checks
 * membership each time, so this is a routing hint, never an authority.
 */
let currentWorkspaceId: string | undefined;

export const getWorkspaceId = () => currentWorkspaceId;

/** Returns true when the workspace changed (callers drop cached workspace data). */
export const setWorkspaceId = (id: string | undefined) => {
  const changed = id !== currentWorkspaceId;
  currentWorkspaceId = id;
  return changed;
};
